<template>
  <div class="buy-btn-block" v-if="config.show_buy_btn" @click="onClick">
    <svg-icon :name="btnIcon"
              v-if="[0,1,4,5].includes(config.buy_btn_type)"/>
    <van-button
            class="buy-btn"
            :color="btnColor"
            :plain="[3,7].includes(config.buy_btn_type)"
            :round="[2,3].includes(config.buy_btn_type)"
            :loading="loading"
            v-else size="mini">{{config.buy_btn_text}}
    </van-button>
  </div>
</template>

<script>
  export default {
	name: 'BuyBtn',
	props: {
	  config: Object,
	  loading: Boolean,
	  stop: Boolean,
	  prevent: Boolean,
	},
	components: {},
	data() {
	  return {};
	},
	created() {
	},
	methods: {
	  onClick(e) {
		if (this.$IS_PREVIEW) return;
		if (this.loading) return;
		if (this.stop) {
		  e.stopPropagation();
		}
		if (this.prevent) {
		  e.preventDefault();
		}
		this.$emit('click');
	  }
	},
	computed: {
	  btnIcon() {
		if (this.loading) return 'loading';
		if ([2, 3, 6, 7].includes(this.config.buy_btn_type)) return "";
		return "buy_btn_" + this.config.buy_btn_type;
	  },
	  btnColor() {
		if ([2, 6].includes(this.config.buy_btn_type)) {
		  return "linear-gradient(to right, #FF8000, #ff6400)";
		}
		if ([3, 7].includes(this.config.buy_btn_type)) {
		  return "#ff6400";
		}
		return "";
	  },
	}
  };
</script>

<style lang="less" rel="stylesheet/less">

  .buy-btn-block {
    font-size: 14px;

    svg {
      font-size: 18px;
    }
  }
</style>
